import * as withUserActions from '../actions/users';
import { User } from '../models/user';
import { UserLimiter } from '../models/user-limiter';
import { Limiter } from "../../common/enums/limiter";
import { UserFilters } from '@users/models/user-filters';

const CLIENT_DISPLAY_TEXT = 'Client';
const CLIENT_PARENT_DISPLAY_TEXT = 'Client Parent';

export interface State {
  users: User[];
  loading: boolean;
  error: string;
  limitedByOptions: UserLimiter[];
  currentFilter: UserFilters;
}

export const INITIAL_STATE: State = {
  users: [],
  loading: false,
  error: '',
  limitedByOptions: [new UserLimiter(Limiter.ClientRef, CLIENT_DISPLAY_TEXT), new UserLimiter(Limiter.ClientParentRef, CLIENT_PARENT_DISPLAY_TEXT)],
  currentFilter: 'All'
}

export function reducer(state: State = INITIAL_STATE, action: withUserActions.Actions) {
  var errorMessage: string;

  switch (action.type) {
    case withUserActions.LOAD:
      {
        return {
          ...state,
          error: '',
          loading: true
        };
      }
    case withUserActions.LOAD_COMPLETE:
      {
        return {
          ...state,
          error: '',
          loading: false,
          users: action.payload
        };
      }
    case withUserActions.LOAD_ERROR:
      {
        errorMessage = '';
        if (action.payload.hasOwnProperty('message')) {
          errorMessage = action.payload.message;
        }

        return {
          ...state,
          error: errorMessage,
          loading: false,
          users: []
        };
      }
    case withUserActions.SET_USERS_FILTER:
    {
      return {
        ...state,
        currentFilter: action.payload
      };
    }
    default:
      {
        return state;
      }
  }
}
